import { Injectable } from '@angular/core';
import { ErrorService } from '@app/services/error.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Period, SlaTemplate } from '@data/models/sla-period.model';
import { catchError, map } from 'rxjs/operators';
import { toParams } from '@shared/utils/query-to-params';
import { FilterParams } from '@claranet/node-search-filter';

const PERIOD_SERVICE_API_ROOT = '/core/v1/projects/-/periods';
const SLA_TEMPLATE_SERVICE_API_ROOT = '/core/v1/projects/-/sla-template';

@Injectable()
export class SlaPeriodService {
    private errors;

    constructor(
        private errorService: ErrorService,
        private http: HttpClient,
    ) {
        this.errors = this.errorService.slaPeriodErrors;
    }

    public listPeriods(filterParams: FilterParams): Observable<Period[]> {
        const params = toParams(filterParams);
        return this.http.get<{ periods: Period[] }>(PERIOD_SERVICE_API_ROOT, { params }).pipe(
            map((result) => result.periods),
            catchError(this.errorService.errorHandler<Period[]>(this.errors, 'Récupération des périodes', []))
        );
    }

    public listSlaTemplates(filterParams: FilterParams): Observable<SlaTemplate[]> {
        const params = toParams(filterParams);
        return this.http.get<{ sla: SlaTemplate[] }>(SLA_TEMPLATE_SERVICE_API_ROOT, { params }).pipe(
            map((result) => result.sla),
            catchError(this.errorService.errorHandler<SlaTemplate[]>(this.errors, 'Récupération des sla standards', []))
        );
    }
}
